<template>
	<div>
		<h4 class="section-title">Edit category</h4>
		<form @submit.prevent="onSubmit">
			
			<div class="form-group input-content">
				<label>Name</label>
				<input type="text" v-model="category_data.name" class="form-control" v-validate="'required'" name="name">
				<span class="input-error-msg">{{ errors.first('name') }}</span>
			</div>

			<button type="submit" class="button">Submit</button>
			<router-link :to="{ name : 'admin.categories.index' }" tag="button" class="button dark-button">Back</router-link>
		</form>
	</div>
</template>

<script>
export default {
	data : function(){
		return {
			id : this.$route.params.agency_id,
			category_data : {
				name : ''
			}
		}
	},

	created : function(){
		this.getCategory();
	}, 

	methods : {
		getCategory : function(){

			var params = {
				id : this.id
			}

			this.$store.dispatch('getCategory', params).then((res) => {
				this.category_data = res.data.data;
			}).catch((error) => {	
				console.log(error);
			})
		},
		onSubmit : function(){

			this.$validator.validateAll().then((result) => {
				if(result){
					this.$store.dispatch('editCategory', this.category_data).then((res) => {
						console.log("OK", res);
						this.$router.push({ name : 'admin.categories.index' });
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/categories/AdminCategoryEditComponent.vue